// Rutas canónicas de la tienda v5 — single source of truth para nav/footer.
// Fase 3 confirma/ajusta los paths finales al crear las páginas React.
// Internas (react-router <Link to>):
export const TV5_ROUTES = {
  home: '/',
  kits: '/kits',
  tienda: '/catalogo', // Sub-fase 4.5: catálogo v5 público (antes '/tienda/catalogo' viejo)
  producto: '/producto', // base; detalle = `${producto}/${slug}` (ProductoDetalle, Fase 3 pág. 6)
  comoFunciona: '/como-funciona',
  barrios: '/barrios',
  limpackflex: '/limpackflex',
  faq: '/faq',
  porteros: '/porteros',
  empresas: '/empresas',
  cuadra: '/cuadra', // Fase 3: path final (la maqueta se llamaba tienda-v5-vecinos, ruta = /cuadra)
  // Sub-fase 4.5: /checkout es el checkout REAL one-shot (CheckoutFlow + Checkout Pro). El CTA
  // "Ir a pagar" del carrito v5 va acá. (Interinamente, entre 4.3 y 4.5, apuntó al tienda viejo.)
  checkout: '/checkout',
  quienesSomos: '/como-funciona#somos',
};

// Externas (<a href>): panel cliente, contacto, legales.
export const TV5_EXTERNAL = {
  cuenta: 'https://panel.limpack.uy/cliente', // ClienteInicio — RequireAuth redirige a login y vuelve
  whatsapp: 'https://wa.me/59898610001',
  instagram: 'https://www.instagram.com/limpackuy/',
  mail: 'mailto:hola@limpack.uy',
  terminos: 'https://limpack.uy/terminos',
  privacidad: 'https://limpack.uy/privacidad',
};
